// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"8adfd962","488":"105e010a"}[chunkId] + ".chunk.js";
};